<template>
  <div>
    <Navbar></Navbar>
    <div class="mt-4 ms-4 d-flex col-2">
      <select name="" id="" class="form-control">
        <option value="">--請選擇--</option>
        <option v-for="option in options" :value="option.Value">{{  option.Value }}</option>
      </select>
    </div>
  </div>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import { useAPIStore, useUtilsStore } from '@/store';
import { onMounted, ref } from 'vue';
const utilsStore = useUtilsStore();
const apiStore = useAPIStore();
const options = ref([]);
onMounted(async () => {
  // options.value = await apiStore.getUserNickName('admin',true);
})
</script>

<style lang="scss" scoped>

</style>